import { useLocation, useParams } from 'react-router-dom';
import { gql, useQuery } from '@apollo/client';
import { CSGetEntity, Entity, EntityUser } from '@admiin-com/ds-graphql';
import { useMemo } from 'react';
import { useCurrentEntityId } from '../../../hooks/useSelectedEntity/useSelectedEntity';

export const useClientSelection = (overrideClientId?: string) => {
  const { id } = useParams();
  const { pathname } = useLocation();
  const clientId =
    overrideClientId ??
    id ??
    (pathname.includes('clients') ? pathname.split('/').pop() : undefined);

  const { data, loading } = useQuery(gql(CSGetEntity), {
    variables: {
      id: clientId,
    },
    skip: !clientId || (!overrideClientId && !pathname.includes('clients')),
    notifyOnNetworkStatusChange: true,
    fetchPolicy: 'cache-and-network',
  });

  const entityId = useCurrentEntityId();
  const selectedClient: Entity | null = useMemo(
    () => data?.getEntity ?? null,
    [data]
  );

  const accountantUser = useMemo(
    () =>
      selectedClient?.entityUsers?.items.find(
        (user: EntityUser | null) =>
          user?.role === 'ACCOUNTANT' && user?.firmId === entityId
      ),
    [selectedClient, entityId]
  );

  const clientUser = useMemo(
    () =>
      selectedClient?.entityUsers?.items.find(
        (user: EntityUser | null) => user?.role === 'OWNER'
      ),
    [selectedClient]
  );

  const client = useMemo(() => {
    return selectedClient
      ? {
          ...selectedClient,
          clientGroupCode: accountantUser?.clientGroupCode,
          clientCode: accountantUser?.clientCode,
        }
      : null;
  }, [selectedClient, accountantUser]);

  return {
    selectedClient: client,
    loading,
    clientUser,
    accountantUser,
  };
};
